var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoAutoVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.093,
    cy: 32.093,
    r: 20.093,
    fill: "#008000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3433 29.404L23.0604 29.016C23.5558 28.7116 24.07 28.4391 24.6001 28.2C26.3508 27.4071 28.2508 26.9979 30.1729 27H30.6449C32.9131 27.0016 35.145 27.5708 37.1372 28.6556L38.5085 29.4037C40.1136 29.4217 41.6878 29.8486 43.0824 30.6436C43.6491 30.9686 43.999 31.5716 44 32.2248V34.5999C44 34.821 43.821 35 43.5999 35H42.2568C41.82 36.2463 40.4556 36.9025 39.2093 36.4657C38.5233 36.2253 37.9841 35.6859 37.7437 35H27.0568C26.62 36.2463 25.2555 36.9025 24.0093 36.4657C23.3234 36.2253 22.784 35.6859 22.5436 35H22.4001C22.3491 35 22.2987 34.9904 22.2513 34.9715L20.9557 34.4517C20.377 34.2225 19.9979 33.6623 20 33.04V29.8C20 29.6011 20.1463 29.4323 20.3433 29.404ZM38.4325 34.52C38.6094 35.3857 39.4546 35.9442 40.3203 35.7673C41.1862 35.5903 41.7446 34.7451 41.5677 33.8792C41.3906 33.0135 40.5454 32.4551 39.6797 32.632C38.9347 32.7842 38.3999 33.4396 38.4001 34.2C38.4001 34.3075 38.411 34.4147 38.4325 34.52ZM31.2 29.4001H36.8312L36.7541 29.3579C35.0439 28.4286 33.1444 27.9017 31.2 27.8176V29.4001ZM30.4001 27.8H30.1737C28.5617 27.7982 26.9644 28.1042 25.4671 28.7017L26.1655 29.4001H30.4001V27.8ZM23.2324 34.52C23.4093 35.3857 24.2546 35.9442 25.1204 35.7673C25.9862 35.5903 26.5446 34.7451 26.3677 33.8792C26.1908 33.0135 25.3454 32.4551 24.4797 32.632C23.7347 32.7842 23.1999 33.4396 23.2 34.2C23.2 34.3075 23.2109 34.4147 23.2324 34.52Z",
    fill: "#FBFDFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3,
    y: 5,
    width: 60.186,
    height: 60.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAutoVerde);
export default __webpack_public_path__ + "static/media/iconoAutoVerde.69e36a611f00f902c7622f7093ed09e3.svg";
export { ForwardRef as ReactComponent };